import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const informationPageUsersSectionK = {
  deleteConfirmationMessage: "information_page_users_section.deleteConfirmationMessage",
  markAsInactive: "information_page_users_section.markAsInactive",
  users: "information_page_users_section.users",
  user: "information_page_users_section.user",
  extendedAccess: "information_page_users_section.extendedAccess",
  invoiceHistory: "information_page_users_section.invoiceHistory",
  newUser: "information_page_users_section.newUser",
  addUser: "information_page_users_section.addUser",
  deleteUser: "information_page_users_section.deleteUser",
  sendInvitation: "information_page_users_section.sendInvitation",
  access: "information_page_users_section.access",
  editUser: "information_page_users_section.editUser",
  nameEmail: "information_page_users_section.nameEmail",
  companyInformation: "information_page_users_section.companyInformation",
};

export const useInformationPageUsersSectionT = () => {
  const { t, i18n } = useTranslation();
  
  return useMemo(
    () => ({
      deleteConfirmationMessage: t(informationPageUsersSectionK.deleteConfirmationMessage),
      markAsInactive: t(informationPageUsersSectionK.markAsInactive),
      users: t(informationPageUsersSectionK.users),
      user: t(informationPageUsersSectionK.user),
      extendedAccess: t(informationPageUsersSectionK.extendedAccess),
      invoiceHistory: t(informationPageUsersSectionK.invoiceHistory),
      newUser: t(informationPageUsersSectionK.newUser),
      addUser: t(informationPageUsersSectionK.addUser),
      deleteUser: t(informationPageUsersSectionK.deleteUser),
      sendInvitation: t(informationPageUsersSectionK.sendInvitation),
      access: t(informationPageUsersSectionK.access),
      editUser: t(informationPageUsersSectionK.editUser),
      nameEmail: t(informationPageUsersSectionK.nameEmail),
      companyInformation: t(informationPageUsersSectionK.companyInformation),
    }),
    [i18n.language]
  );
};